import type { ResolvedContactField } from '@chatbot/shared-types';

const LABELS: Record<string, string> = {
  manual: 'editado por vos',
  erp: 'del sistema de la clínica',
  channel: 'del perfil de WhatsApp/Telegram',
  identifier: 'del identificador del canal',
  userId: 'sin datos — es el identificador',
};

const STYLES: Record<string, string> = {
  manual: 'bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300',
  erp: 'bg-success-50 text-success-700 dark:bg-success-900/30 dark:text-success-300',
  channel: 'bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300',
  identifier: 'bg-neutral-100 text-content-tertiary dark:bg-neutral-800 dark:text-content-tertiary',
  userId: 'bg-neutral-100 text-content-tertiary dark:bg-neutral-800 dark:text-content-tertiary',
};

/**
 * De dónde salió el dato que se está mostrando.
 *
 * Sin esto, un operador no puede distinguir un nombre que él escribió de uno
 * que trajo el ERP — y por lo tanto no sabe si puede confiar en él ni por qué
 * cambió solo.
 */
export function SourceChip({ source }: { source: string | null }) {
  if (!source) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
        STYLES[source] ?? STYLES.channel
      }`}
    >
      {LABELS[source] ?? source}
    </span>
  );
}

/** Las otras versiones del mismo dato, para que nada quede oculto. */
export function FieldAlternatives({ field }: { field: ResolvedContactField }) {
  if (field.alternatives.length === 0) return null;
  return (
    <p className="text-xs text-content-tertiary dark:text-content-tertiary mt-1">
      También conocido como:{' '}
      {field.alternatives.map((a, i) => (
        <span key={`${a.source}-${a.value}`}>
          {i > 0 && ', '}
          <span className="font-medium">{a.value}</span>{' '}
          <span className="text-content-tertiary">({LABELS[a.source] ?? a.source})</span>
        </span>
      ))}
    </p>
  );
}
